var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRnf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 55,
    viewBox: "0 0 59 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M36.2406 24.9063C36.4053 24.5474 36.6866 24.2381 37.0502 24.016C37.4138 23.794 37.8439 23.669 38.2879 23.6562H55.3635C56.3862 23.6562 57.0777 24.3773 56.9131 25.2685L51.5111 53.321C51.4158 53.7646 51.1496 54.1667 50.7563 54.4611C50.363 54.7554 49.8661 54.9243 49.3475 54.94H6.53059C6.29746 54.9479 6.06535 54.9091 5.85212 54.8268C5.63889 54.7444 5.45021 54.6206 5.30058 54.4649C5.15094 54.3092 5.04433 54.1257 4.98894 53.9286C4.93356 53.7315 4.93087 53.5259 4.98108 53.3277L9.57345 29.4467C9.6706 29.0044 9.93761 28.604 10.3307 28.3111C10.7238 28.0181 11.2196 27.8501 11.737 27.8344H31.4584C33.4767 27.8276 35.4581 26.6163 36.2406 24.9063Z",
    fill: "#1A7384"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M36.2406 24.9063C36.4053 24.5474 36.6866 24.2381 37.0502 24.016C37.4138 23.794 37.8439 23.669 38.2879 23.6562H55.3635C56.3862 23.6562 57.0777 24.3773 56.9131 25.2685L51.5111 53.321C51.4158 53.7646 51.1496 54.1667 50.7563 54.4611C50.363 54.7554 49.8661 54.9243 49.3475 54.94H6.53059C6.29746 54.9479 6.06535 54.9091 5.85212 54.8268C5.63889 54.7444 5.45021 54.6206 5.30058 54.4649C5.15094 54.3092 5.04433 54.1257 4.98894 53.9286C4.93356 53.7315 4.93087 53.5259 4.98108 53.3277L9.57345 29.4467C9.6706 29.0044 9.93761 28.604 10.3307 28.3111C10.7238 28.0181 11.2196 27.8501 11.737 27.8344H31.4584C33.4767 27.8276 35.4581 26.6163 36.2406 24.9063Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M29.4445 0L16.5234 39.0521L46.0804 46.4497L58.9995 7.39766L29.4445 0Z",
    fill: "#1A7384"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M29.4445 0L16.5234 39.0521L46.0804 46.4497L58.9995 7.39766L29.4445 0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8711 1.72656L16.5234 39.0484L45.0752 46.195L56.6481 7.56753L28.8711 1.72656Z",
    fill: "#1A7384"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M28.8711 1.72656L16.5234 39.0484L45.0752 46.195L56.6481 7.56753L28.8711 1.72656Z",
    fill: "#1A7384"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8711 1.72656L16.5234 39.0484L45.0752 46.195L56.6481 7.56753L28.8711 1.72656Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M28.8711 1.72656L16.5234 39.0484L45.0752 46.195L56.6481 7.56753L28.8711 1.72656Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3382 12.3007C41.2755 10.3739 41.0501 7.44589 38.8349 5.76087C36.6197 4.07585 33.2535 4.27187 31.3162 6.19869C29.379 8.12551 29.6044 11.0535 31.8196 12.7385C34.0348 14.4235 37.401 14.2275 39.3382 12.3007Z",
    fill: "#1A7384"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1577 12.7792C33.3556 12.5776 32.6402 12.1737 32.1019 11.6185C31.5637 11.0633 31.2267 10.3817 31.1337 9.65998C31.0407 8.93824 31.1958 8.20872 31.5793 7.56363C31.9629 6.91855 32.5578 6.38685 33.2887 6.03577C34.0196 5.68469 34.8538 5.52998 35.6858 5.5912C36.5178 5.65242 37.3102 5.92681 37.9629 6.3797C38.6157 6.83259 39.0994 7.44364 39.3529 8.13561C39.6064 8.82758 39.6184 9.56939 39.3874 10.2673C39.234 10.7311 38.9771 11.1641 38.6311 11.5415C38.2852 11.9189 37.8572 12.2332 37.3714 12.4665C36.8857 12.6998 36.3518 12.8475 35.8004 12.9012C35.2489 12.9549 34.6907 12.9134 34.1577 12.7792Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3821 16.6432L27.9746 14.2891L27.3663 16.1283L36.7738 18.4824L37.3821 16.6432Z",
    fill: "#1A7384"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0413 31.0633L22.8555 29.7656L20.4907 36.9154L25.6765 38.2131L28.0413 31.0633Z",
    fill: "#1A7384"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3909 35.6571L41.2051 34.3594L38.8403 41.5092L44.0261 42.8068L46.3909 35.6571Z",
    fill: "#1A7384"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2151 33.3602L32.0293 32.0625L29.6645 39.2123L34.8504 40.51L37.2151 33.3602Z",
    fill: "#1A7384"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9832 18.5457L38.6191 16.9531L38.0108 18.7924L44.3749 20.3849L44.9832 18.5457Z",
    fill: "#1A7384"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9403 24.1165L26.6523 18.2891L26.4017 19.0468L49.6896 24.8743L49.9403 24.1165Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6989 22.7961L26.1191 19.8984L25.8685 20.6562L37.4483 23.5538L37.6989 22.7961Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4249 25.2272L39.6797 23.2891L39.4291 24.0468L47.1743 25.9849L47.4249 25.2272Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2037 26.1662L25.5879 21.5078L25.3373 22.2655L43.9531 26.9239L44.2037 26.1662Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2177 28.6339L24.8418 23.2109L24.588 23.9679L45.9638 29.3908L46.2177 28.6339Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9934 25.3451L24.5215 24.7266L24.2709 25.4843L26.7428 26.1028L26.9934 25.3451Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8992 28.577L28.9766 25.8438L28.7259 26.6015L39.6486 29.3347L39.8992 28.577Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2781 32.1634L23.9902 26.3359L23.7396 27.0937L47.0275 32.9211L47.2781 32.1634Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0044 1.36719L14.6445 40.7899L44.4727 47.2947L55.8306 7.87194L26.0044 1.36719Z",
    fill: "#1A7384"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M26.0044 1.36719L14.6445 40.7899L44.4727 47.2947L55.8306 7.87194L26.0044 1.36719Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5676 14.5967C37.2175 13.4835 38.3282 10.7125 37.0483 8.40762C35.7684 6.10271 32.5827 5.13668 29.9328 6.24992C27.2829 7.36316 26.1723 10.1341 27.4522 12.439C28.732 14.7439 31.9177 15.71 34.5676 14.5967Z",
    fill: "#1A7384"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M36.401 11.0845C36.8207 9.08923 35.3014 7.17577 33.0076 6.81065C30.7137 6.44554 28.5138 7.76703 28.094 9.76228C27.6743 11.7575 29.1936 13.671 31.4874 14.0361C33.7813 14.4012 35.9812 13.0797 36.401 11.0845Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5989 17.7575L25.1035 15.6875L24.5686 17.5439L34.064 19.6139L34.5989 17.7575Z",
    fill: "#1A7384"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8378 32.4536L20.6035 31.3125L18.5241 38.5291L23.7584 39.6701L25.8378 32.4536Z",
    fill: "#1A7384"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3554 36.4926L39.1211 35.3516L37.0417 42.5681L42.276 43.7092L44.3554 36.4926Z",
    fill: "#1A7384"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0976 34.4692L29.8633 33.3281L27.7839 40.5447L33.0182 41.6858L35.0976 34.4692Z",
    fill: "#1A7384"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2693 19.4316L35.8457 18.0312L35.3108 19.8877L41.7344 21.288L42.2693 19.4316Z",
    fill: "#1A7384"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4449 24.8429L23.9395 19.7188L23.7191 20.4835L47.2246 25.6077L47.4449 24.8429Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1606 23.8917L23.4727 21.3438L23.2523 22.1085L34.9402 24.6565L35.1606 23.8917Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9778 26.0323L37.1602 24.3281L36.9398 25.0929L44.7574 26.7971L44.9778 26.0323Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7936 27.0649L23.0039 22.9688L22.7835 23.7335L41.5733 27.8297L41.7936 27.0649Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1356 29.3022L22.5371 24.5938L22.3167 25.3586L43.9153 30.067L44.1356 29.3022Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5614 26.7627L22.0664 26.2188L21.846 26.9835L24.3411 27.5275L24.5614 26.7627Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5892 29.6065L26.5645 27.2031L26.3441 27.9679L37.3688 30.3713L37.5892 29.6065Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1051 32.9679L21.5996 27.8438L21.3792 28.6085L44.8847 33.7327L45.1051 32.9679Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M24.837 30.7657C24.8738 30.134 25.5091 29.6875 26.373 29.6875H43.4506C44.4733 29.6875 45.4591 30.3092 45.6528 31.0774L50.7798 53.545C50.9735 54.3132 50.2994 54.9366 49.2768 54.9366H6.45398C5.42937 54.9366 4.44349 54.3132 4.2498 53.545L0.0331831 34.6777C-0.160506 33.9094 0.513532 33.2861 1.53815 33.2861H21.2518C23.2759 33.2861 24.7557 32.2416 24.837 30.7657Z",
    fill: "#1A7384"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRnf);
export default __webpack_public_path__ + "static/media/rnf.6a6f72302c3d2700e92047af8416208f.svg";
export { ForwardRef as ReactComponent };